module.exports = __webpack_public_path__ + "media/react/assets/OnboardingSettingsIcon-91d4740bc9dd88c6378e82c96ad7274a.svg";